


























































































































import { Component, Vue } from 'vue-property-decorator';
import rules from '@/Data/formRules';

interface ServisMarkup {
  id?: string;
  metaSearchAgency: any;
  percentageMarkup: number;
  fixedMarkup: number;
  currencyId: string;
  webServiceId: any;
  fromAirportId: string;
  toAirportId: string;
}

@Component
export default class AddServisMarkupModal extends Vue {
  dialog = true;
  rules = rules;
  isEdit = false;
  metaSearchAgencies: any[] = [];
  currencies: any[] = [];
  metaSearchAgency: any = null;
  airports = '';
  airportError = '';
  airportRules = [
    (v: string) => {
      if (!v) return true; // Boş geçilebilir
      if (v.length > 0 && v.length < 7) return 'Havalimanı kodu 6 karakter olmalıdır (XXX-XXX)';
      if (!/^[A-Za-z]{3}-[A-Za-z]{3}$/.test(v)) return 'Geçerli bir havalimanı kodu giriniz (XXX-XXX)';
      return true;
    }
  ];
  servisMarkup: ServisMarkup = {
    metaSearchAgency: null,
    percentageMarkup: 0,
    fixedMarkup: 0,
    currencyId: '',
    webServiceId: '',
    fromAirportId: '',
    toAirportId: ''
  };
  webServices: any[] = [];

  async created() {
    await this.getServices();
    await this.getCurrencies();
    await this.getWebServices();

    if (this.$store.state.servisMarkup.editAuxiliaryMarkup) {
      const editData = this.$store.state.servisMarkup.editAuxiliaryMarkup;
      this.isEdit = true;
      this.servisMarkup = {
        id: editData.id,
        metaSearchAgency: null,
        percentageMarkup: Number(editData.percentageMarkup),
        fixedMarkup: Number(editData.fixedMarkup),
        currencyId: editData.currencyId,
        webServiceId: editData.service.id,
        fromAirportId: editData.fromAirportId || '',
        toAirportId: editData.toAirportId || ''
      };
      
      if (editData.fromAirportId && editData.toAirportId) {
        this.airports = `${editData.fromAirportId}-${editData.toAirportId}`;
      }

      // Meta search agency'yi bulmak için
      const foundAgency = this.metaSearchAgencies.find(
        agency => agency.agencyId === editData.agency.id
      );
      if (foundAgency) {
        this.metaSearchAgency = foundAgency;
        console.log('Found Agency:', foundAgency);
      }

      console.log('Edit Data:', editData);
      console.log('Servis Markup:', this.servisMarkup);
      console.log('Meta Search Agency:', this.metaSearchAgency);
      console.log('Meta Search Agencies:', this.metaSearchAgencies);
    }
  }

  async getServices() {
    // Meta arama servislerini getiren API çağrısı
    const response = await this.$store.dispatch('servisMarkup/getMetaSearchAgencies');
    this.metaSearchAgencies = response.items;
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  
  }

  async getWebServices() {
    try {
      const response = await this.$store.dispatch('servisMarkup/getWebServiceDefinitions');
      this.webServices = response.items.sort((a, b) => a.name.localeCompare(b.name));
    } catch (error) {
      console.error('Web servisleri alınırken hata oluştu:', error);
      this.$toast.error('Web servisleri alınamadı');
    }
  }

  async saveServisMarkup() {
    if (!this.metaSearchAgency || !this.servisMarkup.webServiceId || 
        !this.servisMarkup.fixedMarkup || !this.servisMarkup.currencyId) {
      this.$toast.error('Lütfen tüm zorunlu alanları doldurunuz');
      return;
    }

    // Havalimanı validasyonu
    if (this.airports && !this.validateAirport(this.airports)) {
      this.$toast.error('Lütfen geçerli bir havalimanı kodu giriniz (XXX-XXX)');
      return;
    }

    try {
      const payload = {
        id: this.servisMarkup.id,
        serviceId: this.servisMarkup.webServiceId.id,
        agencyId: this.metaSearchAgency.agencyId,
        fixedMarkup: this.servisMarkup.fixedMarkup,
        percentageMarkup: this.servisMarkup.percentageMarkup,
        currencyId: this.servisMarkup.currencyId,
        fromAirportId: this.servisMarkup.fromAirportId,
        toAirportId: this.servisMarkup.toAirportId
      };

      if (this.isEdit) {
        await this.$store.dispatch({
          type: 'servisMarkup/saveServisMarkup',
          data: payload
        });
        this.$toast.success('Kayıt güncellendi');
      } else {
        await this.$store.dispatch({
          type: 'servisMarkup/addWebServiceMarkup',
          data: payload
        });
        this.$toast.success('Kayıt eklendi');
      }

      this.closeDialog();
    } catch (error) {
      console.error('Kaydetme işlemi sırasında hata:', error);
      this.$toast.error('Bir hata oluştu');
    }
  }

  cancelDialog() {
    this.$emit('closed');
  }

  closeDialog() {
    this.$emit('closed');
  }

  handleAirportInput(value: string) {
    this.airportError = '';
    if (value) {
      if (value.length === 7) {
        if (!/^[A-Za-z]{3}-[A-Za-z]{3}$/.test(value)) {
          this.airportError = 'Geçerli bir havalimanı kodu giriniz (XXX-XXX)';
          return;
        }
      }
      if (value.includes('-')) {
        const [from, to] = value.split('-');
        this.servisMarkup.fromAirportId = from;
        this.servisMarkup.toAirportId = to;
      } else {
        this.servisMarkup.fromAirportId = '';
        this.servisMarkup.toAirportId = '';
      }
    } else {
      this.servisMarkup.fromAirportId = '';
      this.servisMarkup.toAirportId = '';
    }
  }

  validateAirport(value: string): boolean {
    if (!value) return true;
    return /^[A-Za-z]{3}-[A-Za-z]{3}$/.test(value);
  }
}
